export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9037.275bbb9a.jpg";